import _definePage_default_0 from '/app/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/src/pages/access-control.vue?definePage&vue'
import _definePage_default_3 from '/app/src/pages/apps/ecommerce/logistics/actions/map/[date].vue?definePage&vue'
import _definePage_default_4 from '/app/src/pages/apps/ecommerce/logistics/groups/details/[id].vue?definePage&vue'
import _definePage_default_5 from '/app/src/pages/apps/ecommerce/order/details/[id].vue?definePage&vue'
import _definePage_default_6 from '/app/src/pages/apps/ecommerce/order/list/index.vue?definePage&vue'
import _definePage_default_7 from '/app/src/pages/apps/logistics/fleet.vue?definePage&vue'
import _definePage_default_8 from '/app/src/pages/login.vue?definePage&vue'
import _definePage_default_9 from '/app/src/pages/not-authorized.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/app/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/app/src/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'ecommerce',
        /* internal name: 'apps-ecommerce' */
        /* no component */
        children: [
          {
            path: 'acquisition',
            name: 'apps-ecommerce-acquisition',
            component: () => import('/app/src/pages/apps/ecommerce/acquisition.vue'),
            /* no children */
          },
          {
            path: 'bags',
            /* internal name: 'apps-ecommerce-bags' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-ecommerce-bags',
                component: () => import('/app/src/pages/apps/ecommerce/bags/index.vue'),
                /* no children */
              },
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-bags-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-bags-details-id',
                    component: () => import('/app/src/pages/apps/ecommerce/bags/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'print',
                /* internal name: 'apps-ecommerce-bags-print' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-bags-print',
                    component: () => import('/app/src/pages/apps/ecommerce/bags/print/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'cash-deposits',
            name: 'apps-ecommerce-cash-deposits',
            component: () => import('/app/src/pages/apps/ecommerce/cash-deposits.vue'),
            /* no children */
          },
          {
            path: 'customer',
            /* internal name: 'apps-ecommerce-customer' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-customer-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-customer-details-id',
                    component: () => import('/app/src/pages/apps/ecommerce/customer/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-customer-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-customer-list',
                    component: () => import('/app/src/pages/apps/ecommerce/customer/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'faq',
            /* internal name: 'apps-ecommerce-faq' */
            /* no component */
            children: [
              {
                path: 'create',
                name: 'apps-ecommerce-faq-create',
                component: () => import('/app/src/pages/apps/ecommerce/faq/create.vue'),
                /* no children */
              },
              {
                path: 'faq',
                name: 'apps-ecommerce-faq-faq',
                component: () => import('/app/src/pages/apps/ecommerce/faq/faq.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'logistics',
            /* internal name: 'apps-ecommerce-logistics' */
            /* no component */
            children: [
              {
                path: 'actions',
                /* internal name: 'apps-ecommerce-logistics-actions' */
                /* no component */
                children: [
                  {
                    path: 'map',
                    /* internal name: 'apps-ecommerce-logistics-actions-map' */
                    /* no component */
                    children: [
  _mergeRouteRecord(
                      {
                        path: ':date',
                        name: 'apps-ecommerce-logistics-actions-map-date',
                        component: () => import('/app/src/pages/apps/ecommerce/logistics/actions/map/[date].vue'),
                        /* no children */
                      },
  _definePage_default_3
  )
                    ],
                  },
                  {
                    path: 'orderActions',
                    /* internal name: 'apps-ecommerce-logistics-actions-order-actions' */
                    /* no component */
                    children: [
                      {
                        path: ':date',
                        name: 'apps-ecommerce-logistics-actions-order-actions-date',
                        component: () => import('/app/src/pages/apps/ecommerce/logistics/actions/orderActions/[date].vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'orderDrivingActions',
                    /* internal name: 'apps-ecommerce-logistics-actions-order-driving-actions' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: 'apps-ecommerce-logistics-actions-order-driving-actions',
                        component: () => import('/app/src/pages/apps/ecommerce/logistics/actions/orderDrivingActions/index.vue'),
                        /* no children */
                      },
                      {
                        path: 'components',
                        /* internal name: 'apps-ecommerce-logistics-actions-order-driving-actions-components' */
                        /* no component */
                        children: [
                          {
                            path: 'OrderDrivingActionList',
                            name: 'apps-ecommerce-logistics-actions-order-driving-actions-components-order-driving-action-list',
                            component: () => import('/app/src/pages/apps/ecommerce/logistics/actions/orderDrivingActions/components/OrderDrivingActionList.vue'),
                            /* no children */
                          },
                          {
                            path: 'OrderDrivingActionSelectionCard',
                            name: 'apps-ecommerce-logistics-actions-order-driving-actions-components-order-driving-action-selection-card',
                            component: () => import('/app/src/pages/apps/ecommerce/logistics/actions/orderDrivingActions/components/OrderDrivingActionSelectionCard.vue'),
                            /* no children */
                          },
                          {
                            path: 'OrderDrivingActionTypeCard',
                            name: 'apps-ecommerce-logistics-actions-order-driving-actions-components-order-driving-action-type-card',
                            component: () => import('/app/src/pages/apps/ecommerce/logistics/actions/orderDrivingActions/components/OrderDrivingActionTypeCard.vue'),
                            /* no children */
                          }
                        ],
                      }
                    ],
                  }
                ],
              },
              {
                path: 'driver',
                /* internal name: 'apps-ecommerce-logistics-driver' */
                /* no component */
                children: [
                  {
                    path: 'details',
                    /* internal name: 'apps-ecommerce-logistics-driver-details' */
                    /* no component */
                    children: [
                      {
                        path: ':id',
                        name: 'apps-ecommerce-logistics-driver-details-id',
                        component: () => import('/app/src/pages/apps/ecommerce/logistics/driver/details/[id].vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'list',
                    /* internal name: 'apps-ecommerce-logistics-driver-list' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: 'apps-ecommerce-logistics-driver-list',
                        component: () => import('/app/src/pages/apps/ecommerce/logistics/driver/list/index.vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              },
              {
                path: 'groups',
                /* internal name: 'apps-ecommerce-logistics-groups' */
                /* no component */
                children: [
                  {
                    path: 'details',
                    /* internal name: 'apps-ecommerce-logistics-groups-details' */
                    /* no component */
                    children: [
  _mergeRouteRecord(
                      {
                        path: ':id',
                        name: 'apps-ecommerce-logistics-groups-details-id',
                        component: () => import('/app/src/pages/apps/ecommerce/logistics/groups/details/[id].vue'),
                        /* no children */
                      },
  _definePage_default_4
  )
                    ],
                  },
                  {
                    path: 'list',
                    /* internal name: 'apps-ecommerce-logistics-groups-list' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: 'apps-ecommerce-logistics-groups-list',
                        component: () => import('/app/src/pages/apps/ecommerce/logistics/groups/list/index.vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              },
              {
                path: 'storage',
                /* internal name: 'apps-ecommerce-logistics-storage' */
                /* no component */
                children: [
                  {
                    path: 'details',
                    /* internal name: 'apps-ecommerce-logistics-storage-details' */
                    /* no component */
                    children: [
                      {
                        path: ':id',
                        name: 'apps-ecommerce-logistics-storage-details-id',
                        component: () => import('/app/src/pages/apps/ecommerce/logistics/storage/details/[id].vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'list',
                    /* internal name: 'apps-ecommerce-logistics-storage-list' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: 'apps-ecommerce-logistics-storage-list',
                        component: () => import('/app/src/pages/apps/ecommerce/logistics/storage/list/index.vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              }
            ],
          },
          {
            path: 'manage-review',
            name: 'apps-ecommerce-manage-review',
            component: () => import('/app/src/pages/apps/ecommerce/manage-review.vue'),
            /* no children */
          },
          {
            path: 'order',
            /* internal name: 'apps-ecommerce-order' */
            /* no component */
            children: [
              {
                path: 'approval',
                /* internal name: 'apps-ecommerce-order-approval' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-order-approval-id',
                    component: () => import('/app/src/pages/apps/ecommerce/order/approval/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'availability',
                /* internal name: 'apps-ecommerce-order-availability' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-order-availability',
                    component: () => import('/app/src/pages/apps/ecommerce/order/availability/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-order-details' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':id',
                    name: 'apps-ecommerce-order-details-id',
                    component: () => import('/app/src/pages/apps/ecommerce/order/details/[id].vue'),
                    /* no children */
                  },
  _definePage_default_5
  )
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-order-list' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'apps-ecommerce-order-list',
                    component: () => import('/app/src/pages/apps/ecommerce/order/list/index.vue'),
                    /* no children */
                  },
  _definePage_default_6
  )
                ],
              },
              {
                path: 'plan',
                /* internal name: 'apps-ecommerce-order-plan' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-order-plan',
                    component: () => import('/app/src/pages/apps/ecommerce/order/plan/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'outsource',
            /* internal name: 'apps-ecommerce-outsource' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-outsource-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-outsource-details-id',
                    component: () => import('/app/src/pages/apps/ecommerce/outsource/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'ignore-items',
                /* internal name: 'apps-ecommerce-outsource-ignore-items' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-outsource-ignore-items-id',
                    component: () => import('/app/src/pages/apps/ecommerce/outsource/ignore-items/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-outsource-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-outsource-list',
                    component: () => import('/app/src/pages/apps/ecommerce/outsource/list/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'mapping',
                /* internal name: 'apps-ecommerce-outsource-mapping' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-outsource-mapping-id',
                    component: () => import('/app/src/pages/apps/ecommerce/outsource/mapping/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'pricing',
                /* internal name: 'apps-ecommerce-outsource-pricing' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-outsource-pricing',
                    component: () => import('/app/src/pages/apps/ecommerce/outsource/pricing/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'outsource-payments',
            name: 'apps-ecommerce-outsource-payments',
            component: () => import('/app/src/pages/apps/ecommerce/outsource-payments.vue'),
            /* no children */
          },
          {
            path: 'partners',
            /* internal name: 'apps-ecommerce-partners' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-ecommerce-partners',
                component: () => import('/app/src/pages/apps/ecommerce/partners/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'pricing',
            /* internal name: 'apps-ecommerce-pricing' */
            /* no component */
            children: [
              {
                path: 'add',
                /* internal name: 'apps-ecommerce-pricing-add' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-pricing-add',
                    component: () => import('/app/src/pages/apps/ecommerce/pricing/add/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-pricing-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-pricing-details-id',
                    component: () => import('/app/src/pages/apps/ecommerce/pricing/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-pricing-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-pricing-list',
                    component: () => import('/app/src/pages/apps/ecommerce/pricing/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'product',
            /* internal name: 'apps-ecommerce-product' */
            /* no component */
            children: [
              {
                path: 'category-list',
                name: 'apps-ecommerce-product-category-list',
                component: () => import('/app/src/pages/apps/ecommerce/product/category-list.vue'),
                /* no children */
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-product-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-list',
                    component: () => import('/app/src/pages/apps/ecommerce/product/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'referrals',
            name: 'apps-ecommerce-referrals',
            component: () => import('/app/src/pages/apps/ecommerce/referrals.vue'),
            /* no children */
          },
          {
            path: 'settings',
            name: 'apps-ecommerce-settings',
            component: () => import('/app/src/pages/apps/ecommerce/settings.vue'),
            /* no children */
          },
          {
            path: 'user',
            /* internal name: 'apps-ecommerce-user' */
            /* no component */
            children: [
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-user-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-user-list',
                    component: () => import('/app/src/pages/apps/ecommerce/user/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'logistics',
        /* internal name: 'apps-logistics' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-logistics-dashboard',
            component: () => import('/app/src/pages/apps/logistics/dashboard.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'fleet',
            name: 'apps-logistics-fleet',
            component: () => import('/app/src/pages/apps/logistics/fleet.vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      },
      {
        path: 'permissions',
        /* internal name: 'apps-permissions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-permissions',
            component: () => import('/app/src/pages/apps/permissions/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'roles',
        /* internal name: 'apps-roles' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-roles',
            component: () => import('/app/src/pages/apps/roles/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('/app/src/pages/apps/user/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'view',
            /* internal name: 'apps-user-view' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-user-view-id',
                component: () => import('/app/src/pages/apps/user/view/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/app/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_8
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/app/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_9
  )
]
